export default __webpack_public_path__ + "static/media/saibaba-newburgh4.0b45a014.jpg";